export default __webpack_public_path__ + "87eb0b6476d3575d728af488ae64140b.png";